// Main recording function
async function recordCanvas(options) {
  const {
    canvas,
    duration = 3000,
    fps = 60,
    mimeType = 'video/webm'
  } = options; // Validate inputs

  if (!canvas) {
    throw new Error('Canvas is required');
  } // Create stream from canvas


  const stream = canvas.captureStream(fps);
  const mediaRecorder = new MediaRecorder(stream, {
    mimeType,
    videoBitsPerSecond: 2500000 // 2.5 Mbps

  }); // Collect chunks of recorded data

  const chunks = [];

  mediaRecorder.ondataavailable = event => {
    if (event.data.size > 0) {
      chunks.push(event.data);
    }
  }; // Start recording


  mediaRecorder.start(); // Wait for recording to complete

  await new Promise(resolve => {
    setTimeout(() => {
      mediaRecorder.stop();
      resolve();
    }, duration);
  }); // Wait for the final chunk

  await new Promise(resolve => {
    mediaRecorder.onstop = () => resolve();
  }); // Clean up

  stream.getTracks().forEach(track => track.stop()); // Create final blob and URL

  const blob = new Blob(chunks, {
    type: mimeType
  });
  const url = URL.createObjectURL(blob);
  return {
    blob,
    url
  };
}

function waitForSelector(selector) {
  let timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  return new Promise((resolve, reject) => {
    const observer = new MutationObserver(() => {
      const element = document.querySelector(selector);

      if (element) {
        observer.disconnect();
        resolve(element);
      }
    });
    observer.observe(document, {
      childList: true,
      subtree: true
    }); // Reject the promise if the element doesn't appear within a certain time

    const timeoutId = setTimeout(() => {
      observer.disconnect();
      reject(new Error(`Timeout: Selector "${selector}" not found within the specified time`));
    }, timeout); // Clean up the timeout when the promise is resolved or rejected

    return () => clearTimeout(timeoutId);
  });
} // Download a recording of a canvas element as a video


function downloadRecording(result, fileName) {
  const link = document.createElement('a');
  link.href = result.url;
  link.download = fileName;
  document.body.appendChild(link);
  link.dispatchEvent(new MouseEvent('click', {
    bubbles: true,
    cancelable: true,
    view: window
  }));
  document.body.removeChild(link);
  URL.revokeObjectURL(result.url);
}

export { recordCanvas, downloadRecording, waitForSelector };